if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
             window.location = window.routes.cart_url;
             // window.location = '/checkout/';
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          // this.submitButtonText.textContent = window.variantStrings.addToCart;
                  

let cid = document.querySelector('.product-form input[name="id"]').getAttribute("value");
document.querySelectorAll(".custom-master-li").forEach(function(item){
if(item.getAttribute("data-vid") == cid){
  if(document.querySelector(".cws2-product-checkbox-input:checked")){
    console.log("hasChcked")
    document.querySelector("#price-button").innerText = item.getAttribute("data-plus-addon-price");
        if ($(".custom-sub-points-wrapper-top").length > 0) {
      let subPoints = $(".custom-sub-points-wrapper-top").html();
      $(".subify-selling-plan-whole-wrapper").after(subPoints);
    }
        if ($(".custom-one-points-wrapper-top").length > 0) {
      let onePoints = $(".custom-one-points-wrapper-top").html();
      $("#subify-widget-one-time-purchase-text").parents(".subify-choice-box-wrapper").find("div").eq(0).after(onePoints);
    }
  }
  else{
    console.log("hasntChcked")
    setTimeout(function(){
      if ($(".custom-sub-points-wrapper").length > 0 && $(".subify-selling-plan-whole-wrapper").length > 0) {
        $(".product__info-wrapper .product-form__submit #price-button").text($(".subify-choice-box-wrapper.active .subify-choice-price").text());
      }
      else{
        document.querySelector("#price-button").innerText = item.innerText;
      }

        if ($(".custom-sub-points-wrapper-top").length > 0) {
      let subPoints = $(".custom-sub-points-wrapper-top").html();
      $(".subify-selling-plan-whole-wrapper").after(subPoints);
    }
        if ($(".custom-one-points-wrapper-top").length > 0) {
      let onePoints = $(".custom-one-points-wrapper-top").html();
      $("#subify-widget-one-time-purchase-text").parents(".subify-choice-box-wrapper").find("div").eq(0).after(onePoints);
    }
    }, 100)
  }

}
})



// $(document).on("click", `.product-form__submit`, function(){
//   console.log("hhhasdhgajkishdakjhdkashdakjshd");
//   // if($(".cws2-product-checkbox-input").length > 0){
//   // if($(".cws2-product-checkbox-input").is(":checked")){
//   //       console.log("my--------cartttt")
//   //     let formData2 = {
//   //      'items': [{
//   //       'id': 49359430549828,
//   //       'quantity': 1
//   //       }]
//   //     };
      
//   //     fetch(window.Shopify.routes.root + 'cart/add.js', {
//   //       method: 'POST',
//   //       headers: {
//   //         'Content-Type': 'application/json'
//   //       },
//   //       body: JSON.stringify(formData2)
//   //     })
//   //     .then(response => {
//   //       return response.json();
//   //     })
//   //     .then(function(){
//   //       console.log("success--------addded")
//   //       document.dispatchEvent(new CustomEvent('cart:updated', {
//   //          bubbles: true,
//   //        }));
//   //     })
//   //     .catch((error) => {
//   //       console.error('Error:', error);
//   //     });
//   // }
//   // }
// })

          

        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
